import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logoDesktop from '@/assets/epicodds/images/logo/logo.png';
import logoMb from '@/assets/epicodds/images/logo/logoMb.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image src={logoDesktop} alt={THEME_NAME.epicodds} mx="auto" />
      </Show>
      <Hide above="lg">
        <Image src={logoMb} alt={THEME_NAME.epicodds} h="8" />
      </Hide>
    </Link>
  );
}
